import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RsGridModule } from './rs-grid/rs-grid.module';
import { RsGridComponent } from './rs-grid/rs-grid.component';
import { RvrsCreateModule } from './rvrs-create/rvrs-create.module';
import { RvrsCreateComponent } from './rvrs-create/rvrs-create.component';
import { ReviewerModule } from '../../common/component/reviewer/reviewer.module';
import { ReviewerComponent } from '../../common/component/reviewer/reviewer.component';
import { AddEditCustomerGuard } from '../../admin/accounts/manage-customers/add-edit-customer/add-edit-customer.guard'

export const routes: Routes = [
  { path: 'monitor', component: RsGridComponent },
  { path: 'createFromRateAudit', component: RvrsCreateComponent, canDeactivate: [AddEditCustomerGuard] },
  { path: 'importFromRateAuditFile', component: RvrsCreateComponent, canDeactivate: [AddEditCustomerGuard] },
  { path: 'manuallyBuildRateAudit', component: RvrsCreateComponent, canDeactivate: [AddEditCustomerGuard] },
  { path: 'review', component: ReviewerComponent, canDeactivate: [AddEditCustomerGuard] }
];
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    RsGridModule,
    RvrsCreateModule,
    ReviewerModule
  ],
  exports: [RouterModule]
})
export class RvrsAuditRoutingModule { }
